import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { partialUpdateOrg as apiUpdateOrg } from 'api/orgAdmin';
import { Org } from 'api/orgs';
import SearchContextHeaderContainer from 'containers/SearchContextHeaderContainer';
import { ListingUnpublishedPage } from 'modules/main/pages/ListingUnpublished';
import { LoadingPage } from 'modules/main/pages/Loading';
import { useMainSelector } from 'modules/main/store';
import { useMainDispatch } from 'modules/main/store/hooks';
import { fetchOrg, partialUpdateOrg } from 'modules/main/store/slices/orgs';
import { trackPageView } from 'utils/analytics/track/trackPageView';
import { setDocumentTitle } from 'utils/meta';
import { scrollToHash } from 'utils/scrollIntoView';

import { OrgPage } from './OrgPage';

const trackOrg = ({ name, id, orgType }: Org) => {
  trackPageView('Org Listing Page', {
    name,
    id,
    org_type: orgType,
    page_type: 'Org Listings',
  });
};

type Props = {
  orgId: string;
};

export default function OrgPageContainer({ orgId }: Props) {
  const dispatch = useMainDispatch();
  const location = useLocation();
  const { org } = useMainSelector((state) => ({
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    org: state.orgs.byId[orgId],
  }));
  useEffect(() => {
    if (!org) {
      dispatch(fetchOrg(orgId));
    }

    if (org && !org.isFetching && !org.isUnpublished) {
      trackOrg(org);
      setDocumentTitle(org.name);
    }

    setTimeout(() => {
      scrollToHash(location.hash.replace('section-', ''));
    }, 1);
  }, [dispatch, location.hash, org, orgId]);

  const onSubmit = ({
    values,
    handleError,
  }: {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    values: Record<string, any>;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleError: (...args: Array<any>) => any;
  }) => {
    apiUpdateOrg(values)
      .then(() => {
        dispatch(partialUpdateOrg(values));
      })
      .catch(handleError);
  };

  if (!org || org.isFetching) {
    return <LoadingPage />;
  }

  return (
    <SearchContextHeaderContainer
      currentObjectId={orgId}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      render={(searchContext: any) => {
        if (!org.isFetching && org.isUnpublished) {
          return (
            <ListingUnpublishedPage
              listingType="ORG"
              searchContext={searchContext}
            />
          );
        }

        return (
          <OrgPage
            org={org}
            searchContext={searchContext}
            isPublished
            onSubmit={onSubmit}
          />
        );
      }}
    />
  );
}
